import { OwaDate } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import getDatesOnEndPartChanged from './getDatesOnEndPartChanged';

/**
 * This function returns new start and end time based the change of the end time
 * It updates the end time and not the date
 * Sets the end time to be start time if end date is set to before the start
 */

export default function getDatesOnEndTimeChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newDate: OwaDate
): OwaDateRange | null {
    if (prevStartDate && prevEndDate && newDate) {
        return getDatesOnEndPartChanged(prevStartDate, prevEndDate.tz, prevEndDate, newDate);
    }
    return null;
}
